import { lazy } from "react";
import { Routes, Route } from "react-router-dom";
import { routes } from "./routes/routes";
import FullLayout from "./layouts/full-layout/FullLayout";
import BlankLayout from "./layouts/blank-layout/BlankLayout";
import Loadable from "./layouts/full-layout/loadable/Loadable";
import { useAuth } from "./authentication/AuthProvider";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Permission Guard
import { DashboardGuard } from "./guards/DashboardAuthGuard";
import {
  TimeandAttendanceLunchGuard,
  TimeandAttendanceBusinessGuard,
  TimeandAttendancePersonalBusinessGuard,
  TimeandAttendanceMissingPunchesGuard,
  TimeandAttendanceMyTimePunchesGuard,
  TimeandAttendanceBuildingGuard,
} from "./guards/TimeandAttendanceGuard";
import {
  ExpensePurchaseOrderManageGuard,
  ExpensePurchaseOrderMPCEPOViewerGuard,
  ExpensePurchaseOrderMPCVoteGuard,
  ExpensePurchaseOrderMyEPOGuard,
  ExpensePurchaseOrderSubordinatesGuard,
  ExpensePurchaseOrderApprovalGuard,
} from "./guards/ExpensePurchaseOrderGaurd";
import {
  AttendanceChangeSubmitNewFTOGuard,
  AttendanceChangeApproveFTOGuard,
  AttendanceChangeHRApprovalGuard,
  AttendanceChangeReviewYTDFTOGuard,
  AttendanceChangeAllDepartmentFTOGuard,
  AttendanceChangeFutureDepartmentFTOGuard,
  VisitorGuard,
} from "./guards/AttendanceChangeGuard";
import {
  DocumentManagementAllDocsGuard,
  DocumentManagementNewECNGuard,
  DocumentManagementNewFCDGuard,
  DocumentManagementNewLITGuard,
  DocumentManagementNewSOPGuard,
  DocumentManagementNewWIGuard,
  DocumentManagementApprovalGuard,
} from "./guards/DocumentManagementGuard";

import {
  AdminAddEmployeeGuard,
  AdminEmployeeLimitGuard,
  AdminAppovalDocumentPersonGuard,
  AdminRolesGuard,
  EmployeeViewGourd,
  HRAddEmployeeLimitGuard,
  AdminMasterDetailsGuard,
} from "./guards/AdminGuard";
import { EvalutionProcessGuard } from "./guards/EvalutionFormGuard";
import LetsKnowEachotherDetails from "./views/hr-module/lets-know-each-otherDetails/ViewLetsKnowEachotherDetails";
import { ThankyouPage } from "./components/attendance-change/view-fto/ThankyouPage";
import { ThankyouPageForEpo } from "./views/expense-purchase-order/ThankyouPageEPo";
import NewPassword from "./views/authentication/NewPassword";
import Create from "./views/hr-module/pre-recruitment-process/Addquestion/Create";
import { AllQuestion } from "./views/hr-module/pre-recruitment-process/Allquestion/AllQuestion";
import HolidayList from "./views/hr-module/holiday/HolidayList";
import { AddResume } from "./views/hr-module/pre-recruitment-process/AddResume/AddResume";
import AllCandidateCV from "./views/hr-module/pre-recruitment-process/AllCandidateCV/AllCandidateCV";
import {
  CandidateCVmanageGuard,
  CandidateCVViewGuard,
} from "./guards/CandidateCVGuard";
import { QuestionAddGuard, QuestionGetGuard } from "./guards/QuestionGuard";
import CreateVisitor from "./views/attendance-change/Visitor/Create";
import { AllVisitors } from "./views/attendance-change/Visitor/Visitors/AllVisitors";
import { ThankyouPageForVisisotr } from "./views/attendance-change/Visitor/ThankyouPageForVisisotr";
import CreateVisitorW from "./views/attendance-change/Visitor/WithoutLogin/CreateVisitorW";
import { ThankYouTicket } from "./views/ticket/ThankYouTicket";
import ApplicationManagement from "./views/admin/ApplicationManagement/ApplicationManagement";
import RequestTypeMaster from "./views/admin/RequestTypeManagement/RequestTypeManagement";
import DashboardModulesManagement from "./views/admin/DashboardModulesManagement/DashboardModulesManagement";
import MedicalCardPage from "./views/hr-module/medical-card/MedicalCardPage";
import OfficeIdCardPage from "./views/hr-module/office-id-card/OfficeIdCardPage";
import ContractIdCardPage from "./views/hr-module/contract-id-card/ContractIdCardPage";
import IDCardsPage from "./views/hr-module/id-cards/IDCardsPage";
import EmployeeApprovalPage from "./views/admin/employee-approval/EmployeeApprovalPage";
import { EmptEmployeeOfTheMonth } from "./views/hr-module/employee-of-the-month/EmptEmployeeOfTheMonth";
import EmployeeOfMonthVoteModal from "./views/hr-module/employee-of-the-month/EmployeeOfMonthVoteModal";
import MasterDatabase from "./views/admin/MasterDatabase/MasterDatabase";
import EpoMaster from "./views/admin/epo-master/EpoMaster";
import FinalNomineeList from "./views/hr-module/employee-of-the-month/FinalNomineeList";
import { ThankyouPageForRecordingRequest } from "./views/cctvrecordingrequest/ThankyouPageForRecordingRequest";
import DeviceData from "./views/asai/device-data/DeviceData";
import TenHoursImportShiftPage from "./views/asai/10-hours-shift/10HourImportShiftPage";
import TenHoursViewShiftPage from "./views/asai/10-hours-shift/10HourViewShiftPage";
import TenHourReportPage from "./views/asai/10-hours-report/10HourReportPage";
import TenHourOffdayReportPage from "./views/asai/10-hours-report/10HourOffdayReportPage";
import TenHourOffdayTimeReportPage from "./views/asai/10-hours-report/10HourOffdayTimeReportPage";
import EightHourReportPage from "./views/asai/8-hours-report/8HourReportPage";
import EightHourOvertimeReportPage from "./views/asai/8-hours-report/8HourOvertimeReportPage";
import EmployeeMonthlyAttendancePage from "./views/asai/employee-monthly-attendance/EmployeeMonthlyAttendancePage";
import LateArrivalDashboard from "./views/time-attendance/late-arrival-dashboard/LateArrivalDashboard";

import TwoMinLateDashboard from "./views/time-attendance/late-arrival-dashboard/TwoMinLateDashboard";
import VisitorAttendanceDashboard from "./views/time-attendance/late-arrival-dashboard/VisitorAttendanceDashboard";
import ShiftMaster from "./views/asaiadmin/shiftmaster/ShiftMaster";
import LeaveBalanceMaster from "./views/asaiadmin/leavebalancemaster/LeaveBalanceMaster";
import MachineMaster from "./views/asaiadmin/machinemaster/MachineMaster";
import OrganizationMaster from "./views/asaiadmin/organizationmaster/OrganizationMaster";
import ShiftWiseRuleConfiguration from "./views/asaiadmin/shift-rule-configuration/ShiftWiseRuleConfiguration";
import ShiftRosterManagementPage from "./views/asai/shift-switch-merge/ShiftRosterManagementPage";
import MonthlyPunchReport from "./views/asai/monthly-punch-report/MonthlyPunchReport";
import EightHoursImportShiftPage1 from "./views/asai/8-hours-shift/8HourImportShiftPage";
import EightHoursViewShiftPage from "./views/asai/8-hours-shift/8HourViewShiftPage";
import AttendanceBonusRuleMaster from "./views/asaiadmin/attendancebonusrule/AttendanceBonusRule";

// import { ApplicationMaster } from "./views/admin/add-Application/ApplicationMaster";
// import EmailForTraining from "./views/hr-module/TrainingModule/training/EmailForTraining";
const ITDashboard = Loadable(
  lazy(() => import("./views/dashboards/ITDashboard")),
);
const ITNews = Loadable(lazy(() => import("./views/dashboards/ITNews")));
const ITProjectUpdates = Loadable(
  lazy(() => import("./views/dashboards/ITProjectUpdates")),
);
const ITOngoingTasks = Loadable(
  lazy(() => import("./views/dashboards/ITOngoingTasks")),
);
const ITPeriodicActionItem = Loadable(
  lazy(() => import("./views/dashboards/ITPeriodicActionItem")),
);
const ITContinuousImprovement = Loadable(
  lazy(() => import("./views/dashboards/ITContinuousImprovement")),
);
const ITKPIs = Loadable(lazy(() => import("./views/dashboards/ITKPIs")));
const ITResponsibilityMatrix = Loadable(
  lazy(() => import("./views/dashboards/ITResponsibilityMatrix")),
);
const ITWorkloadDistributor = Loadable(
  lazy(() => import("./views/dashboards/ITWorkloadDistributor")),
);
const ITDepartmentReports = Loadable(
  lazy(() => import("./views/dashboards/ITDepartmentReports")),
);
const ITDepartmentTraining = Loadable(
  lazy(() => import("./views/dashboards/ITDepartmentTraining")),
);
const ITCsharpStructure = Loadable(
  lazy(() => import("./views/dashboards/ITCsharpStructure")),
);
const ITMVCStructure = Loadable(
  lazy(() => import("./views/dashboards/ITMVCStructure")),
);
const ITReactDotNetStructure = Loadable(
  lazy(() => import("./views/dashboards/ITReactDotNetStructure")),
);
const ITDatabaseStructure = Loadable(
  lazy(() => import("./views/dashboards/ITDatabaseStructure")),
);
const ITDatabaseCreation = Loadable(
  lazy(() => import("./views/dashboards/ITDatabaseCreation")),
);
const ITDatabaseUsage = Loadable(
  lazy(() => import("./views/dashboards/ITDatabaseUsage")),
);
const ITSchedulerDataTransfer = Loadable(
  lazy(() => import("./views/dashboards/ITSchedulerDataTransfer")),
);
const ITOnboardingTechNews = Loadable(
  lazy(() => import("./views/dashboards/ITTechNews")),
);
const ITOnboardingGit = Loadable(
  lazy(() => import("./views/dashboards/ITOnboardingGit")),
);
const ITOnboardingFrontend = Loadable(
  lazy(() => import("./views/dashboards/ITOnboardingFrontend")),
);
const ITOnboardingReact = Loadable(
  lazy(() => import("./views/dashboards/ITOnboardingReact")),
);
const ITOnboardingLanguages = Loadable(
  lazy(() => import("./views/dashboards/ITOnboardingLanguages")),
);
const ITOnboardingDotNet = Loadable(
  lazy(() => import("./views/dashboards/ITOnboardingDotNet")),
);
const ITAzureServers = Loadable(
  lazy(() => import("./views/dashboards/ITAzureServers")),
);
const ITManagerialPlan = Loadable(
  lazy(() => import("./views/dashboards/ITManagerialPlan")),
);

const Login = Loadable(lazy(() => import("./views/authentication/Login")));
const Error = Loadable(lazy(() => import("./views/authentication/Error")));
const UnAuthorized = Loadable(
  lazy(() => import("./views/unAuthorized/UnAuthorized")),
);
const Register = Loadable(
  lazy(() => import("./views/authentication/Register")),
);

const ResetPassword = Loadable(
  lazy(() => import("./views/authentication/ResetPassword")),
);

const ForgotPassword = Loadable(
  lazy(() => import("./views/authentication/ForgotPassword")),
);
const ChangePassword = Loadable(
  lazy(() => import("./views/authentication/ChangePassword")),
);
const Dashboard = Loadable(lazy(() => import("./views/dashboards/Dashboard1")));
const Dashboard2 = Loadable(
  lazy(() => import("./views/dashboards/Dashboard2")),
);
const Dashboard3 = Loadable(
  lazy(() => import("./views/dashboards/Dashboard3")),
);
// TimeAndAttendance
const AttendanceForLunch = Loadable(
  lazy(() => import("./views/time-attendance/lunch/Lunch")),
);
const VisitorPassDashboard = Loadable(
  lazy(() => import("./views/time-attendance/VisitorDashboard")),
);
const AttendanceForBusiness = Loadable(
  lazy(() => import("./views/time-attendance/business/Business")),
);

const AttendanceForPersonalBusiness = Loadable(
  lazy(() =>
    import("./views/time-attendance/personal-business/PersonalBusiness"),
  ),
);
const MissingPunch = Loadable(
  lazy(() =>
    import("./views/time-attendance/my-missing-punches/MissingPunches"),
  ),
);
const MyTimePunchRecords = Loadable(
  lazy(() => import("./views/time-attendance/my-time-punch-records/Records")),
);
const Building = Loadable(
  lazy(() => import("./views/time-attendance/whos-in-Building/Building")),
);
// EPO
const EPODashboard = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/epo-dashboard/EPODashboard.js"),
  ),
);
const EPOCreate = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/create-new-epo/CreateForm_New"),
  ),
);
const VendorList = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/ViewVendor"),
  ),
);
const EPOEdit = Loadable(
  lazy(() => import("./views/expense-purchase-order/edit-epo/EditForm")),
);
const EPOMPCViewer = Loadable(
  lazy(() => import("./views/expense-purchase-order/mpc-epo-viewer/EPODetail")),
);
const EPOVote = Loadable(
  lazy(() => import("./views/expense-purchase-order/mpc-vote-for-epo/EPOVote")),
);
const EPOMyList = Loadable(
  lazy(() => import("./views/expense-purchase-order/my-epos/EPOList")),
);
const EPOPayment = Loadable(
  lazy(() => import("./views/expense-purchase-order/epo-payment/PaymentEPO")),
);
const EPOSubordinate = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/subordinate-epo/MySubordinate"),
  ),
);
const EPOApproval = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/approval-for-epo/Approval"),
  ),
);
const EPODirectorApproval = Loadable(
  lazy(() =>
    import("./views/expense-purchase-order/approval-for-epo/ApprovalDirector"),
  ),
);
const EPOView = Loadable(
  lazy(() => import("./components/expense-purchase-order/view-epo/ViewEPO")),
);

//hr
const HRInterview = Loadable(
  lazy(() =>
    import("./views/hr-module/pre-recruitment-process/PreRecruitmentProcess"),
  ),
);
const AllRecrutiees = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/pre-recruitment-process/pre-recruitee-list/AllRecruitees"
    ),
  ),
);
//Evalution Form
// const AllEvalutionCandidate = Loadable(
//   lazy(() =>
//     import(
//       "./views/evalutionForm/EvalutionCandidates"
//     )
//   )
// );
const AllEvalutionCandidate = Loadable(
  lazy(() => import("./views/evalutionForm/EvalutionCandidates")),
);
const EvalutionForm = Loadable(
  lazy(() => import("./views/evalutionForm/EvalutionForm")),
);

const WelcomeNewEmployee = Loadable(
  lazy(() =>
    import("./views/hr-module/welcome-new-employee/WelcomeNewEmployee"),
  ),
);

const EmployeeofTheMonthNomination = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/employee-of-the-month/EmployeeOfTheMonthNomination"
    ),
  ),
);

const AllNominee = Loadable(
  lazy(() => import("./views/hr-module/employee-of-the-month/AllNominee")),
);
const HRNominee = Loadable(
  lazy(() =>
    import("./views/hr-module/employee-of-the-month/GetPendingHRApprovals"),
  ),
);
const MPCNominee = Loadable(
  lazy(() =>
    import("./views/hr-module/employee-of-the-month/GetPendingMPCApprovals"),
  ),
);
const NomineeById = Loadable(
  lazy(() => import("./views/hr-module/employee-of-the-month/NomineeView")),
);

const GetPendingSupervisorApprovals = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/employee-of-the-month/GetPendingSupervisorApprovals"
    ),
  ),
);

const MpcNomineeVote = Loadable(
  lazy(() =>
    import("./views/hr-module/employee-of-the-month/EmployeeOfMonthVoteModal"),
  ),
);
const AllGatePass = Loadable(
  lazy(() => import("./views/hr-module/gate-pass/AllGatePass")),
);
const AddGatePass = Loadable(
  lazy(() => import("./views/hr-module/gate-pass/GetPass")),
);
const GatePassView = Loadable(
  lazy(() => import("./views/hr-module/gate-pass/GatePassView")),
);

const AllLetsKnowEachOtherDetails = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/lets-know-each-otherDetails/AllLetsKnowEachOtherDetails"
    ),
  ),
);
const LetsKnowEachOtherDetailsById = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/lets-know-each-otherDetails/ViewLetsKnowEachotherDetails"
    ),
  ),
);
const AddLetsKnowEachOtherDetails = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/lets-know-each-otherDetails/LetsKnowEachotherDetails"
    ),
  ),
);

const AddLeaveSheet = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/LeaveSheet")),
);
const AllLeaveSheet = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/LeaveSheetList")),
);
const SupervisorDashboard = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/SupervisorDashboard")),
);
const LeaveSheetById = Loadable(
  lazy(() => import("./views/hr-module/LeaveSheet/ViewLeaveSheet")),
);

const TrainingSheetForm = Loadable(
  lazy(() =>
    import("./views/hr-module/TrainingModule/training/TrainingSheetForm"),
  ),
);
const TrainingList = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/training/TrainingList")),
);
const ViewTraining = Loadable(
  lazy(() =>
    import(
      "./views/hr-module/TrainingModule/training/training-vew/TrainingSheetForm"
    ),
  ),
);
const EmailForTraining = Loadable(
  lazy(() =>
    import("./views/hr-module/TrainingModule/training/EmailForTraining"),
  ),
);

const CourseList = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/courses/CourseList")),
);
const CourseForm = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/courses/CourseForm")),
);
const CourseDetailsById = Loadable(
  lazy(() => import("./views/hr-module/TrainingModule/courses/ViewCourse")),
);

//FTO
const FTOCreate = Loadable(
  lazy(() => import("./views/attendance-change/new-fto/CreateFTO")),
);
const FTOSchedule = Loadable(
  lazy(() => import("./views/attendance-change/fto-schedule/MyFTO")),
);
const FTOReviewYTD = Loadable(
  lazy(() => import("./views/attendance-change/ytd-fto-status/ReviewYTD")),
);
const FTOApprove = Loadable(
  lazy(() => import("./views/attendance-change/fto-approve/ApproveFTO")),
);
const FTOHrApprove = Loadable(
  lazy(() => import("./views/attendance-change/hr-approval/HrApprove")),
);
const FTOAllMyDept = Loadable(
  lazy(() => import("./views/attendance-change/all-fto-department/ShowAllFTO")),
);
const FTOFutureMyDept = Loadable(
  lazy(() =>
    import("./views/attendance-change/future-fto-department/FutureFTO"),
  ),
);
const AllCOAMyDept = Loadable(
  lazy(() => import("./views/attendance-change/all-coa-department/COA")),
);
const FutureCOAMyDept = Loadable(
  lazy(() =>
    import("./views/attendance-change/future-coa-department/FutureCOA"),
  ),
);
const FTOView = Loadable(
  lazy(() => import("./components/attendance-change/view-fto/ViewFTO")),
);
const EmailFTOView = Loadable(
  lazy(() => import("./components/attendance-change/view-fto/EmailViewFto")),
);

//Document Management System
const AllDocuments = Loadable(
  lazy(() => import("./views/document-management/all-document/ListDocument")),
);
const CreateECN = Loadable(
  lazy(() => import("./views/document-management/new-ecn/ECN")),
);
const CreateFCD = Loadable(
  lazy(() => import("./views/document-management/new-fcd/FCD")),
);
const CreateLIT = Loadable(
  lazy(() => import("./views/document-management/new-lit/LIT")),
);
const CreateSOP = Loadable(
  lazy(() => import("./views/document-management/new-sop/SOP")),
);
const CreateWI = Loadable(
  lazy(() => import("./views/document-management/new-wi/WI")),
);
const DocumentView = Loadable(
  lazy(() => import("./views/document-management/view-document/ViewDocument")),
);
const DocumentEdit = Loadable(
  lazy(() => import("./views/document-management/edit-document/EditDocument")),
);

const DocumentApproval = Loadable(
  lazy(() =>
    import("./views/document-management/document-awaiting-approval/Approval"),
  ),
);

//Admin
const AddEmployee = Loadable(
  lazy(() => import("./views/admin/add-employee/Create")),
);

const EmployeeLimit = Loadable(
  lazy(() => import("./views/admin/emloyee-limit/EmployeeList")),
);

const Approval = Loadable(
  lazy(() => import("./views/admin/approval-document/Approval")),
);

const RoleRights = Loadable(
  lazy(() => import("./views/admin/roles-rights/RolesRights")),
);
const MasterDetails = Loadable(
  lazy(() => import("./views/admin/master-details/MasterManagement")),
);

// Change Request
const CRCreate = Loadable(
  lazy(() =>
    import("./views/change-request/create-change-request/CreateNewCRForm"),
  ),
);
const ChangeRequestList = Loadable(
  lazy(() =>
    import("./views/change-request/change-request-list/AllChangeRequests"),
  ),
);
//Hierarchy
const Hierarchy = Loadable(
  lazy(() => import("./views/Genricinformation/Hierarchy")),
);
const PhoneBook = Loadable(
  lazy(() => import("./views/phonebook/PhonebookPage")),
);
const Hierarchy2 = Loadable(
  lazy(() => import("./views/Genricinformation/Hierarchy2")),
);
const PlantLayout = Loadable(
  lazy(() => import("./views/Genricinformation/PlantLayout")),
);
const Ticket = Loadable(lazy(() => import("./views/ticket/index")));
const TicketAdd = Loadable(lazy(() => import("./views/ticket/index")));

const TicketApprovalPending = Loadable(
  lazy(() => import("./views/ticket/TicketApprovalPage")),
);
const RecordingRequest = Loadable(
  lazy(() => import("./views/Genricinformation/RecordingRequest")),
);
const GetAllRecording = Loadable(
  lazy(() => import("./views/Genricinformation/GetAllRecording")),
);
const RecordingView = Loadable(
  lazy(() => import("./views/Genricinformation/ViewRecording")),
);
const RecordingEdit = Loadable(
  lazy(() => import("./views/Genricinformation/EditRecording")),
);
const VisitorDisplay = Loadable(
  lazy(() => import("./views/visitor-display/visitorDisplay")),
);
const MonthlySchedule = Loadable(
  lazy(() => import("./views/monthlySchedule/monthlySchedule")),
);

const Holiday = Loadable(lazy(() => import("./views/Holiday/Holiday")));
const MaterialPassDisplay = Loadable(
  lazy(() => import("./views/visitor-display/MaterialPass")),
);

//  Asai Panel

const LeaveTypeMaster = Loadable(
  lazy(() => import("./views/asaiadmin/leavemaster/LeaveTypeMaster")),
);

const ViewLeaveApplicationForm = Loadable(
  lazy(() =>
    import("./views/hr-module/LeaveSheet/ViewLeaveApplicationForm")
  )
);


const AppWrapper = () => {
  let auth = useAuth();
  return (
    <>
      <Routes>
        <Route element={auth?.user ? <FullLayout /> : <BlankLayout />}>
          <Route path={routes.shiftMaster.match} element={<DashboardGuard />}>
            <Route path={routes.shiftMaster.match} element={<ShiftMaster />} />
          </Route>
          <Route
            path={routes.monthlyPunchReport.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.monthlyPunchReport.match}
              element={<MonthlyPunchReport />}
            />  
          </Route>
          <Route path={routes.shiftSwitch.match} element={<DashboardGuard />}>
            <Route
              path={routes.shiftSwitch.match}
              element={<ShiftRosterManagementPage />}
            />
          </Route>
          <Route
            path={routes.shiftRuleConfiguration.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.shiftRuleConfiguration.match}
              element={<ShiftWiseRuleConfiguration />}
            />
          </Route>
          <Route
            path={routes.leaveBalanceMaster.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.leaveBalanceMaster.match}
              element={<LeaveBalanceMaster />}
            />
          </Route>

          <Route path={routes.machineMaster.match} element={<DashboardGuard />}>
            <Route
              path={routes.machineMaster.match}
              element={<MachineMaster />}
            />
          </Route>

          <Route
            path={routes.organizationMaster.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.organizationMaster.match}
              element={<OrganizationMaster />}
            />
          </Route>

                    <Route
            path={routes.attendanceBonusRuleMaster.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.attendanceBonusRuleMaster.match}
              element={<AttendanceBonusRuleMaster />}
            />
          </Route>

                    <Route
            path={routes.attendanceBonusRuleMaster.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.attendanceBonusRuleMaster.match}
              element={<AttendanceBonusRuleMaster />}
            />
          </Route>

          <Route path={routes.deviceData.match} element={<DashboardGuard />}>
            <Route path={routes.deviceData.match} element={<DeviceData />} />
          </Route>

          <Route
            path={routes.employeeMonthlyAttendance.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.employeeMonthlyAttendance.match}
              element={<EmployeeMonthlyAttendancePage />}
            />
          </Route>

          <Route
            path={routes.tenHoursImportShift.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.tenHoursImportShift.match}
              element={<TenHoursImportShiftPage />}
            />
          </Route>

          <Route
            path={routes.tenHoursViewShift.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.tenHoursViewShift.match}
              element={<TenHoursViewShiftPage />}
            />
          </Route>

          {/* ASAI - 8 Hours Shift */}

          <Route
            path={routes.eightHoursAddEditShift.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.eightHoursAddEditShift.match}
              element={<EightHoursImportShiftPage1 />}
            />
          </Route>

          <Route
            path={routes.eightHoursViewShift.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.eightHoursViewShift.match}
              element={<EightHoursViewShiftPage />}
            />
          </Route>

          <Route
            path={routes.tenHoursReport.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.tenHoursReport.match}
              element={<TenHourReportPage />}
            />
          </Route>

          <Route
            path={routes.tenHoursOffdayReport.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.tenHoursOffdayReport.match}
              element={<TenHourOffdayReportPage />}
            />
          </Route>

          <Route
            path={routes.tenHoursOffdayTimeReport.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.tenHoursOffdayTimeReport.match}
              element={<TenHourOffdayTimeReportPage />}
            />
          </Route>

          <Route
            path={routes.eightHoursReport.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.eightHoursReport.match}
              element={<EightHourReportPage />}
            />
          </Route>

          <Route
            path={routes.eightHoursOvertimeReport.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.eightHoursOvertimeReport.match}
              element={<EightHourOvertimeReportPage />}
            />
          </Route>

          <Route
            path={routes?.home.match}
            element={auth.user ? <Dashboard /> : <Login />}
          />
          <Route path={routes?.error.match} element={<Error />} />
          <Route path={routes?.unAuthorized.match} element={<UnAuthorized />} />
          <Route
            path={routes?.resetPassword.match}
            element={<ResetPassword />}
          />
          <Route
            path={routes?.forgotPassword.match}
            element={<ForgotPassword />}
          />
          {/* Non Auth Route */}
          <Route path={routes?.login.match} element={<Login />} />
          <Route path={routes?.register.match} element={<Register />} />
          {/* Auth Route */}
          <Route
            path={routes.changePassword.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes?.changePassword.match}
              element={<ChangePassword />}
            />
          </Route>
          <Route
            path={routes.monthlySchedule.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.monthlySchedule.match}
              element={<MonthlySchedule />}
            />
          </Route>
          <Route path={routes.Holiday.match} element={<DashboardGuard />}>
            <Route path={routes.Holiday.match} element={<Holiday />} />
          </Route>
          <Route path={routes.phonebook.match} element={<DashboardGuard />}>
            <Route path={routes.phonebook.match} element={<PhoneBook />} />
          </Route>
          <Route
            path={routes?.setNewPassword.match}
            element={<NewPassword />}
          />
          {/* Dashboard */}
          <Route path={routes.dashboard.match} element={<DashboardGuard />}>
            <Route path={routes.dashboard.match} element={<Dashboard />} />
          </Route>

          <Route path={routes.itDashboard.match} element={<DashboardGuard />}>
            <Route path={routes.itDashboard.match} element={<ITDashboard />} />
          </Route>

          <Route path={routes.itNews.match} element={<DashboardGuard />}>
            <Route path={routes.itNews.match} element={<ITNews />} />
          </Route>

          <Route
            path={routes.itProjectUpdates.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itProjectUpdates.match}
              element={<ITProjectUpdates />}
            />
          </Route>

          <Route
            path={routes.itOngoingTasks.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOngoingTasks.match}
              element={<ITOngoingTasks />}
            />
          </Route>

          <Route
            path={routes.itPeriodicActionItem.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itPeriodicActionItem.match}
              element={<ITPeriodicActionItem />}
            />
          </Route>

          <Route
            path={routes.itContinuousImprovement.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itContinuousImprovement.match}
              element={<ITContinuousImprovement />}
            />
          </Route>

          <Route path={routes.itKPIs.match} element={<DashboardGuard />}>
            <Route path={routes.itKPIs.match} element={<ITKPIs />} />
          </Route>

          <Route
            path={routes.epoMaster.match}
            element={<AdminMasterDetailsGuard />}
          >
            <Route path={routes.epoMaster.match} element={<EpoMaster />} />
          </Route>

          <Route
            path={routes.itResponsibilityMatrix.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itResponsibilityMatrix.match}
              element={<ITResponsibilityMatrix />}
            />
          </Route>

          <Route
            path={routes.itWorkloadDistributor.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itWorkloadDistributor.match}
              element={<ITWorkloadDistributor />}
            />
          </Route>

          <Route
            path={routes.itDepartmentReports.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itDepartmentReports.match}
              element={<ITDepartmentReports />}
            />
          </Route>

          <Route
            path={routes.itDepartmentTraining.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itDepartmentTraining.match}
              element={<ITDepartmentTraining />}
            />
          </Route>

          <Route
            path={routes.itCSharpStructure.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itCSharpStructure.match}
              element={<ITCsharpStructure />}
            />
          </Route>

          <Route
            path={routes.itMVCStructure.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itMVCStructure.match}
              element={<ITMVCStructure />}
            />
          </Route>

          <Route
            path={routes.itReactDotNetStructure.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itReactDotNetStructure.match}
              element={<ITReactDotNetStructure />}
            />
          </Route>

          <Route
            path={routes.itDatabaseStructure.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itDatabaseStructure.match}
              element={<ITDatabaseStructure />}
            />
          </Route>

          <Route
            path={routes.itDatabaseCreation.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itDatabaseCreation.match}
              element={<ITDatabaseCreation />}
            />
          </Route>

          <Route
            path={routes.itDatabaseUsage.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itDatabaseUsage.match}
              element={<ITDatabaseUsage />}
            />
          </Route>

          <Route
            path={routes.itSchedulerDataTransfer.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itSchedulerDataTransfer.match}
              element={<ITSchedulerDataTransfer />}
            />
          </Route>

          <Route
            path={routes.itOnboardingTechNews.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOnboardingTechNews.match}
              element={<ITOnboardingTechNews />}
            />
          </Route>
          <Route
            path={routes.itOnboardingGit.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOnboardingGit.match}
              element={<ITOnboardingGit />}
            />
          </Route>

          <Route
            path={routes.itOnboardingFrontend.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOnboardingFrontend.match}
              element={<ITOnboardingFrontend />}
            />
          </Route>

          <Route
            path={routes.itOnboardingReact.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOnboardingReact.match}
              element={<ITOnboardingReact />}
            />
          </Route>

          <Route
            path={routes.itOnboardingLanguages.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOnboardingLanguages.match}
              element={<ITOnboardingLanguages />}
            />
          </Route>

          <Route
            path={routes.itOnboardingDotNet.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itOnboardingDotNet.match}
              element={<ITOnboardingDotNet />}
            />
          </Route>

          <Route
            path={routes.itAzureServers.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itAzureServers.match}
              element={<ITAzureServers />}
            />
          </Route>

          <Route
            path={routes.itManagerialPlan.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.itManagerialPlan.match}
              element={<ITManagerialPlan />}
            />
          </Route>

          <Route path={routes.dashboard2.match} element={<DashboardGuard />}>
            <Route path={routes.dashboard2.match} element={<Dashboard2 />} />
          </Route>
          <Route path={routes.dashboard3.match} element={<DashboardGuard />}>
            <Route path={routes.dashboard3.match} element={<Dashboard3 />} />
          </Route>
          {/* Hierarchy */}
          <Route path={routes.hierarchy.match} element={<DashboardGuard />}>
            <Route path={routes.hierarchy.match} element={<Hierarchy />} />
          </Route>
          <Route path={routes.hierarchy2.match} element={<DashboardGuard />}>
            <Route path={routes.hierarchy2.match} element={<Hierarchy2 />} />
          </Route>
          <Route
            path={routes.RecordingRequest.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.RecordingRequest.match}
              element={<RecordingRequest />}
            />
          </Route>
          <Route path={routes.Recordinglist.match} element={<DashboardGuard />}>
            <Route
              path={routes.Recordinglist.match}
              element={<GetAllRecording />}
            />
          </Route>
          <Route path={routes.RecordingView.match} element={<DashboardGuard />}>
            <Route
              path={routes.RecordingView.match}
              element={<RecordingView />}
            />
          </Route>
          <Route path={routes.RecordingEdit.match} element={<DashboardGuard />}>
            <Route
              path={routes.RecordingEdit.match}
              element={<RecordingEdit />}
            />
          </Route>
          <Route path={routes.planylayout.match} element={<DashboardGuard />}>
            <Route path={routes.planylayout.match} element={<PlantLayout />} />
          </Route>
          <Route path={routes.ticketAdd.match} element={<DashboardGuard />}>
            <Route
              path={routes.ticketAdd.match}
              element={<TicketAdd defaultTab="add" />}
            />
          </Route>
          <Route path={routes.ticket.match} element={<DashboardGuard />}>
            <Route path={routes.ticket.match} element={<Ticket />} />
          </Route>
          <Route
            path={routes.ticketMailApproval.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.ticketMailApproval.match}
              element={<ThankYouTicket />}
            />
          </Route>
          <Route
            path={routes.ticketApproval.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.ticketApproval.match}
              element={<TicketApprovalPending />}
            />
          </Route>
          <Route
            path={routes.VisitorDisplay.match}
            element={<VisitorDisplay />}
          />
          <Route
            path={routes.MaterialPassDisplay.match}
            element={<MaterialPassDisplay />}
          />
          {/* TimeAndAttendance */}
          <Route
            path={routes.attendanceForLunch.match}
            element={<TimeandAttendanceLunchGuard />}
          >
            <Route
              path={routes.attendanceForLunch.match}
              element={<AttendanceForLunch />}
            />
          </Route>
          <Route
            path={routes.visitorPassDashboard.match}
            element={<VisitorAttendanceDashboard />}
          />
          
          <Route
            path={routes.twoMinLateDashboard.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.twoMinLateDashboard.match}
              element={<TwoMinLateDashboard />}
            />
          </Route>

          <Route
            path={routes.attendanceForBusiness.match}
            element={<TimeandAttendanceBusinessGuard />}
          >
            <Route
              path={routes.attendanceForBusiness.match}
              element={<AttendanceForBusiness />}
            />
          </Route>
          <Route
            path={routes.attendanceForPersonalBusiness.match}
            element={<TimeandAttendancePersonalBusinessGuard />}
          >
            <Route
              path={routes.attendanceForPersonalBusiness.match}
              element={<AttendanceForPersonalBusiness />}
            />
          </Route>
          <Route
            path={routes.missingPunch.match}
            element={<TimeandAttendanceMissingPunchesGuard />}
          >
            <Route
              path={routes.missingPunch.match}
              element={<MissingPunch />}
            />
          </Route>
          <Route
            path={routes.myTimePunchRecords.match}
            element={<TimeandAttendanceMyTimePunchesGuard />}
          >
            <Route
              path={routes.myTimePunchRecords.match}
              element={<MyTimePunchRecords />}
            />
          </Route>
          <Route
            path={routes.building.match}
            element={<TimeandAttendanceBuildingGuard />}
          >
            <Route path={routes.building.match} element={<Building />} />
          </Route>
          {/* EPO */}
          <Route
            path={routes.epoDashboard.match}
            element={<ExpensePurchaseOrderManageGuard />}
          >
            <Route
              path={routes.epoDashboard.match}
              element={<EPODashboard />}
            />
          </Route>
          <Route
            path={routes.epoCreate.match}
            element={<ExpensePurchaseOrderManageGuard />}
          >
            <Route path={routes.epoCreate.match} element={<EPOCreate />} />
          </Route>
          <Route
            path={routes.vendorList.match}
            element={<ExpensePurchaseOrderManageGuard />}
          >
            <Route path={routes.vendorList.match} element={<VendorList />} />
          </Route>
          <Route path={routes.epoEdit.match} element={<DashboardGuard />}>
            <Route path={routes.epoEdit.match} element={<EPOEdit />} />
          </Route>
          <Route
            path={routes.epoDetail.match}
            element={<ExpensePurchaseOrderMPCEPOViewerGuard />}
          >
            <Route path={routes.epoDetail.match} element={<EPOMPCViewer />} />
          </Route>
          <Route
            path={routes.epoVote.match}
            element={<ExpensePurchaseOrderMPCVoteGuard />}
          >
            <Route path={routes.epoVote.match} element={<EPOVote />} />
          </Route>
          <Route
            path={routes.epoList.match}
            element={<ExpensePurchaseOrderMyEPOGuard />}
          >
            <Route path={routes.epoList.match} element={<EPOMyList />} />
          </Route>
          <Route path={routes.epoPayment.match} element={<DashboardGuard />}>
            <Route path={routes.epoPayment.match} element={<EPOPayment />} />
          </Route>
          <Route
            path={routes.epoSubordinate.match}
            element={<ExpensePurchaseOrderSubordinatesGuard />}
          >
            <Route
              path={routes.epoSubordinate.match}
              element={<EPOSubordinate />}
            />
          </Route>
          <Route
            path={routes.epoApproval.match}
            element={<ExpensePurchaseOrderApprovalGuard />}
          >
            <Route path={routes.epoApproval.match} element={<EPOApproval />} />
          </Route>
          <Route
            path={routes.epoDirectorApproval.match}
            element={<ExpensePurchaseOrderApprovalGuard />}
          >
            <Route
              path={routes.epoDirectorApproval.match}
              element={<EPODirectorApproval />}
            />
          </Route>
          <Route path={routes.epoView.match} element={<DashboardGuard />}>
            <Route path={routes.epoView.match} element={<EPOView />} />
          </Route>
          <Route path={routes.epoapproval.match}>
            <Route
              path={routes.epoapproval.match}
              element={<ThankyouPageForEpo />}
            />
          </Route>
          {/* Human Resource Management */}
          {/* Evaluytion Form */}
          {/* <Route path={routes.hrInterviewCreate.match} element={<DashboardGuard />}></Route> */}

          <Route
            path={routes.interviewEvaluationForm.match}
            element={<EvalutionProcessGuard />}
          >
            <Route
              path={routes.interviewEvaluationForm.match}
              element={<EvalutionForm />}
            ></Route>

            <Route
              path={routes.allEvalutionCandidate.match}
              element={<AllEvalutionCandidate />}
            />
          </Route>
          {/* Pre-Recruitment Process */}
          <Route
            path={routes.hrInterviewCreate.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.hrInterviewCreate.match}
              element={<HRInterview />}
            />
          </Route>
          <Route path={routes.addQuestion.match} element={<QuestionAddGuard />}>
            <Route path={routes.addQuestion.match} element={<Create />} />
          </Route>
          <Route path={routes.questionView.match} element={<DashboardGuard />}>
            <Route path={routes.questionView.match} element={<Create />} />
          </Route>
          <Route
            path={routes.editQuestion.match}
            element={<QuestionAddGuard />}
          >
            <Route path={routes.editQuestion.match} element={<Create />} />
          </Route>
          <Route
            path={routes.allQuestionlist.match}
            element={<QuestionGetGuard />}
          >
            <Route
              path={routes.allQuestionlist.match}
              element={<AllQuestion />}
            />
          </Route>
          <Route path={routes.allHolidaylist.match} element={<HolidayList />} />
          <Route
            path={routes.addCandidateCV.match}
            element={<CandidateCVmanageGuard />}
          >
            <Route path={routes.addCandidateCV.match} element={<AddResume />} />
          </Route>
          <Route
            path={routes.getCandidateCV.match}
            element={<CandidateCVViewGuard />}
          >
            <Route
              path={routes.getCandidateCV.match}
              element={<AllCandidateCV />}
            />
          </Route>
          <Route path={routes.allRecruitee.match} element={<DashboardGuard />}>
            <Route
              path={routes.allRecruitee.match}
              element={<AllRecrutiees />}
            />
          </Route>
          {/* Add Course */}
          <Route path={routes.addCourseForm.match} element={<DashboardGuard />}>
            <Route path={routes.addCourseForm.match} element={<CourseForm />} />
          </Route>

          {/* Edit Course - uses the same CourseForm component */}
          <Route path={routes.editCourse.match} element={<DashboardGuard />}>
            <Route path={routes.editCourse.match} element={<CourseForm />} />
          </Route>

          {/* View Course */}
          <Route
            path={routes.viewCourseDetails.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.viewCourseDetails.match}
              element={<CourseDetailsById />}
            />
          </Route>

          <Route
            path={routes.welcomeNewEmpl.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.welcomeNewEmpl.match}
              element={<WelcomeNewEmployee />}
            />
          </Route>
          {/* EmployeeofTheMonthNomination */}
          <Route
            path={routes.EmployeeOfTheMonthNomination.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.EmployeeOfTheMonthNomination.match}
              element={<EmployeeofTheMonthNomination />}
            />
          </Route>
          <Route
            path={routes.editEmployeeOfTheMonthNomination.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.editEmployeeOfTheMonthNomination.match}
              element={<EmployeeofTheMonthNomination />}
            />
          </Route>
          <Route path={routes.allNominee.match} element={<DashboardGuard />}>
            <Route path={routes.allNominee.match} element={<AllNominee />} />
          </Route>
          <Route
            path={routes.finalNomineeList.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.finalNomineeList.match}
              element={<FinalNomineeList />}
            />
          </Route>
          <Route path={routes.hrNominee.match} element={<DashboardGuard />}>
            <Route path={routes.hrNominee.match} element={<HRNominee />} />
          </Route>
          <Route path={routes.mpcNominee.match} element={<DashboardGuard />}>
            <Route path={routes.mpcNominee.match} element={<MPCNominee />} />
          </Route>
          <Route
            path={routes.GetPendingSupervisorApprovals.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.GetPendingSupervisorApprovals.match}
              element={<GetPendingSupervisorApprovals />}
            />
          </Route>
          <Route
            path={routes.mpcNomineeVoteView.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.mpcNomineeVoteView.match}
              element={<MpcNomineeVote />}
            />
          </Route>
          <Route path={routes.nomineeView.match} element={<DashboardGuard />}>
            <Route path={routes.nomineeView.match} element={<NomineeById />} />
          </Route>
          {/* Gate Pass */}
          <Route path={routes.allGatePass.match} element={<DashboardGuard />}>
            <Route path={routes.allGatePass.match} element={<AllGatePass />} />
          </Route>
          <Route path={routes.addGatePass.match} element={<DashboardGuard />}>
            <Route path={routes.addGatePass.match} element={<AddGatePass />} />
          </Route>
          <Route path={routes.gatePassView.match} element={<DashboardGuard />}>
            <Route
              path={routes.gatePassView.match}
              element={<GatePassView />}
            />
          </Route>
          {/* Let's Know Each Other Details */}
          <Route
            path={routes.allLetsKnowEachOtherDetails.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.allLetsKnowEachOtherDetails.match}
              element={<AllLetsKnowEachOtherDetails />}
            />
          </Route>
          <Route
            path={routes.addLetsKnowEachOtherDetails.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.addLetsKnowEachOtherDetails.match}
              element={<AddLetsKnowEachOtherDetails />}
            />
          </Route>
          <Route
            path={routes.updateLetsKnowEachOtherDetails.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.updateLetsKnowEachOtherDetails.match}
              element={<AddLetsKnowEachOtherDetails />}
            />
          </Route>
          <Route
            path={routes.letsKnowEachotherDetailsView.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.letsKnowEachotherDetailsView.match}
              element={<LetsKnowEachotherDetails />}
            />
          </Route>
          {/* TrainingSheetForm */}
          <Route
            path={routes.addTrainingSheetForm.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.addTrainingSheetForm.match}
              element={<TrainingSheetForm />}
            />
          </Route>
          {/* TrainingList */}
          <Route
            path={routes.allTrainingList.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.allTrainingList.match}
              element={<TrainingList />}
            />
          </Route>
          <Route path={routes.viewTraining.match} element={<DashboardGuard />}>
            <Route
              path={routes.viewTraining.match}
              element={<ViewTraining />}
            />
          </Route>
          <Route path={routes.editTraining.match} element={<DashboardGuard />}>
            <Route
              path={routes.editTraining.match}
              element={<TrainingSheetForm />}
            />
          </Route>
          <Route path={routes.idCards.match} element={<DashboardGuard />}>
            <Route path={routes.idCards.match} element={<IDCardsPage />} />
          </Route>
          <Route path={routes.medicalCard.match} element={<DashboardGuard />}>
            <Route
              path={routes.medicalCard.match}
              element={<MedicalCardPage />}
            />
          </Route>
          <Route path={routes.officeIdCard.match} element={<DashboardGuard />}>
            <Route
              path={routes.officeIdCard.match}
              element={<OfficeIdCardPage />}
            />
          </Route>
          <Route
            path={routes.contractIdCard.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.contractIdCard.match}
              element={<ContractIdCardPage />}
            />
          </Route>
          <Route
            path={routes.employeeApproval.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.employeeApproval.match}
              element={<EmployeeApprovalPage />}
            />
          </Route>

          <Route
            path={routes.employeeApprovalDetail.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.employeeApprovalDetail.match}
              element={<EmployeeApprovalPage />}
            />
          </Route>
          <Route
            path={routes.emailForTraining.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.emailForTraining.match}
              element={<EmailForTraining />}
            />
          </Route>
          {/* LeaveSheet */}
          <Route path={routes.allLeaveSheet.match} element={<DashboardGuard />}>
            <Route
              path={routes.allLeaveSheet.match}
              element={<AllLeaveSheet />}
            />
          </Route>
          <Route path={routes.supervisorDashboard.match} element={<DashboardGuard />}>
            <Route
              path={routes.supervisorDashboard.match}
              element={<SupervisorDashboard />}
            />
          </Route>
          <Route path={routes.addLeaveSheet.match} element={<DashboardGuard />}>
            <Route
              path={routes.addLeaveSheet.match}
              element={<AddLeaveSheet />}
            />
          </Route>
          <Route
            path={routes.viewLeaveSheet.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.viewLeaveSheet.match}
              element={<LeaveSheetById />}
            />
            
            </Route>
          <Route
            path={routes.ViewLeavPass.match}
            element={<DashboardGuard />}
          >
          <Route
              path={routes.ViewLeavPass.match}
              element={<ViewLeaveApplicationForm />}
              />
              </Route>
          {/* Training By Course */}
          <Route path={routes.allCourseList.match} element={<DashboardGuard />}>
            <Route path={routes.allCourseList.match} element={<CourseList />} />
          </Route>
          <Route path={routes.addCourseForm.match} element={<DashboardGuard />}>
            <Route path={routes.addCourseForm.match} element={<CourseForm />} />
          </Route>
          <Route
            path={routes.viewCourseDetails.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.viewCourseDetails.match}
              element={<CourseDetailsById />}
            />
          </Route>

          {/* Attendance */}
          <Route
            path={routes.ftoCreate.match}
            element={<AttendanceChangeSubmitNewFTOGuard />}
          >
            <Route path={routes.ftoCreate.match} element={<FTOCreate />} />
          </Route>

          <Route path={routes.ftoEdit.match} element={<DashboardGuard />}>
            <Route path={routes.ftoEdit.match} element={<FTOCreate />} />
          </Route>
          <Route path={routes.ftoList.match} element={<DashboardGuard />}>
            <Route path={routes.ftoList.match} element={<FTOSchedule />} />
          </Route>
          <Route
            path={routes.ftoReviewYTD.match}
            element={<AttendanceChangeReviewYTDFTOGuard />}
          >
            <Route
              path={routes.ftoReviewYTD.match}
              element={<FTOReviewYTD />}
            />
          </Route>
          <Route
            path={routes.ftoApprove.match}
            element={<AttendanceChangeApproveFTOGuard />}
          >
            <Route path={routes.ftoApprove.match} element={<FTOApprove />} />
          </Route>
          <Route
            path={routes.ftoAllDepartment.match}
            element={<AttendanceChangeAllDepartmentFTOGuard />}
          >
            <Route
              path={routes.ftoAllDepartment.match}
              element={<FTOAllMyDept />}
            />
          </Route>
          <Route
            path={routes.ftoFutureDepartment.match}
            element={<AttendanceChangeFutureDepartmentFTOGuard />}
          >
            <Route
              path={routes.ftoFutureDepartment.match}
              element={<FTOFutureMyDept />}
            />
          </Route>
          <Route path={routes.addvisitor.match} element={<VisitorGuard />}>
            <Route path={routes.addvisitor.match} element={<CreateVisitor />} />
          </Route>
          <Route path={routes.addvisitorwithoutlogin.match}>
            <Route
              path={routes.addvisitorwithoutlogin.match}
              element={<CreateVisitorW />}
            />
          </Route>
          <Route path={routes.allvisitorlist.match} element={<VisitorGuard />}>
            <Route
              path={routes.allvisitorlist.match}
              element={<AllVisitors />}
            />
          </Route>
          <Route path={routes.visitorView.match} element={<VisitorGuard />}>
            <Route
              path={routes.visitorView.match}
              element={<CreateVisitor />}
            />
          </Route>
          <Route path={routes.editVisitor.match} element={<VisitorGuard />}>
            <Route
              path={routes.editVisitor.match}
              element={<CreateVisitor />}
            />
          </Route>
          <Route
            path={routes.allCOADepartment.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.allCOADepartment.match}
              element={<AllCOAMyDept />}
            />
          </Route>
          <Route
            path={routes.futureCOADepartment.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.futureCOADepartment.match}
              element={<FutureCOAMyDept />}
            />
          </Route>
          <Route path={routes.viewFTO.match} element={<DashboardGuard />}>
            <Route path={routes.viewFTO.match} element={<FTOView />} />
          </Route>
          <Route
            path={routes.ftoHrApprove.match}
            element={<AttendanceChangeHRApprovalGuard />}
          >
            <Route
              path={routes.ftoHrApprove.match}
              element={<FTOHrApprove />}
            />
          </Route>
          {/* <Route 
          path={routes.emailviewFTO.match}>
            <Route
              path={routes.emailviewFTO.match}
              element={<EmailFTOView />}
            />
          </Route> */}
          <Route path={routes.thankyou.match}>
            <Route path={routes.thankyou.match} element={<ThankyouPage />} />
          </Route>
          <Route
            path={routes.thankyouticket.match}
            element={<ThankYouTicket />}
          />
          <Route
            path={routes.applicationMaster.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.applicationMaster.match}
              element={<ApplicationManagement />}
            />
          </Route>
          <Route
            path={routes.masterDatabase.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.masterDatabase.match}
              element={<MasterDatabase />}
            />
          </Route>
          <Route
            path={routes.requestTypeMaster.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.requestTypeMaster.match}
              element={<RequestTypeMaster />}
            />
          </Route>
          <Route
            path={routes.dashboardModulesManagement.match}
            element={<DashboardGuard />}
          >
            <Route
              path={routes.dashboardModulesManagement.match}
              element={<DashboardModulesManagement />}
            />
          </Route>
          <Route path={routes.visitorapproval.match}>
            <Route
              path={routes.visitorapproval.match}
              element={<ThankyouPageForVisisotr />}
            />
          </Route>
          <Route path={routes.recordingrapproval.match}>
            <Route
              path={routes.recordingrapproval.match}
              element={<ThankyouPageForRecordingRequest />}
            />
          </Route>
          {/* Document Management System */}
          <Route
            path={routes.allDocuments.match}
            element={<DocumentManagementAllDocsGuard />}
          >
            <Route
              path={routes.allDocuments.match}
              element={<AllDocuments />}
            />
          </Route>
          <Route
            path={routes.createECN.match}
            element={<DocumentManagementNewECNGuard />}
          >
            <Route path={routes.createECN.match} element={<CreateECN />} />
          </Route>
          <Route
            path={routes.createFCD.match}
            element={<DocumentManagementNewFCDGuard />}
          >
            <Route path={routes.createFCD.match} element={<CreateFCD />} />
          </Route>
          <Route
            path={routes.createLIT.match}
            element={<DocumentManagementNewLITGuard />}
          >
            <Route path={routes.createLIT.match} element={<CreateLIT />} />
          </Route>
          <Route
            path={routes.createSOP.match}
            element={<DocumentManagementNewSOPGuard />}
          >
            <Route path={routes.createSOP.match} element={<CreateSOP />} />
          </Route>
          <Route
            path={routes.createWI.match}
            element={<DocumentManagementNewWIGuard />}
          >
            <Route path={routes.createWI.match} element={<CreateWI />} />
          </Route>
          <Route path={routes.viewDocument.match} element={<DashboardGuard />}>
            <Route
              path={routes.viewDocument.match}
              element={<DocumentView />}
            />
          </Route>
          <Route path={routes.editDocument.match} element={<DashboardGuard />}>
            <Route
              path={routes.editDocument.match}
              element={<DocumentEdit />}
            />
          </Route>
          <Route
            path={routes.documentMyApproval.match}
            element={<DocumentManagementApprovalGuard />}
          >
            <Route
              path={routes.documentMyApproval.match}
              element={<DocumentApproval />}
            />
          </Route>
          {/* Admin */}
          {/* <Route
            path={routes.addemployee.match}
            element={<HRAddEmployeeLimitGuard />}
          > */}
          <Route path={routes.addemployee.match} element={<AddEmployee />} />
          {/* </Route> */}
          <Route
            path={routes.adminAddEmployee.match}
            element={<AdminAddEmployeeGuard />}
          >
            <Route
              path={routes.adminAddEmployee.match}
              element={<AddEmployee />}
            />
          </Route>
          <Route
            path={routes.editEmployee.match}
            element={<AdminAddEmployeeGuard />}
          >
            <Route path={routes.editEmployee.match} element={<AddEmployee />} />
          </Route>
          <Route
            path={routes.limitEmployee.match}
            element={<AdminEmployeeLimitGuard />}
          >
            <Route
              path={routes.limitEmployee.match}
              element={<EmployeeLimit />}
            />
          </Route>
          <Route
            path={routes.limitEmployees.match}
            element={<HRAddEmployeeLimitGuard />}
          >
            <Route
              path={routes.limitEmployees.match}
              element={<EmployeeLimit />}
            />
          </Route>
          <Route
            path={routes.hrAddEmp.match}
            element={<HRAddEmployeeLimitGuard />}
          >
            <Route path={routes.hrAddEmp.match} element={<EmployeeLimit />} />
          </Route>
          <Route
            path={routes.addemployee.match}
            element={<AdminAddEmployeeGuard />}
          >
            <Route path={routes.addemployee.match} element={<AddEmployee />} />
          </Route>
          <Route
            path={routes.approvalDocument.match}
            element={<AdminAppovalDocumentPersonGuard />}
          >
            <Route
              path={routes.approvalDocument.match}
              element={<Approval />}
            />
          </Route>
          <Route path={routes.roleRights.match} element={<AdminRolesGuard />}>
            <Route path={routes.roleRights.match} element={<RoleRights />} />
          </Route>
          <Route
            path={routes.masterDetails.match}
            element={<AdminMasterDetailsGuard />}
          >
            <Route
              path={routes.masterDetails.match}
              element={<MasterDetails />}
            />
          </Route>
          <Route
            path={routes.employeeView.match}
            element={<EmployeeViewGourd />}
          >
            <Route
              path={routes.employeeView.match}
              element={<AddEmployee />}
            ></Route>
          </Route>
          {/* Change Request */}
          <Route
            path={routes.crCreate.match}
            element={<ExpensePurchaseOrderManageGuard />}
          >
            <Route path={routes.crCreate.match} element={<CRCreate />} />
          </Route>

          <Route
            path={routes.allChangeRequest.match}
            element={<DocumentManagementAllDocsGuard />}
          >
            <Route
              path={routes.allChangeRequest.match}
              element={<ChangeRequestList />}
            />
          </Route>

          <Route path={routes.leaveMaster.match} element={<DashboardGuard />}>
            <Route
              path={routes.leaveMaster.match}
              element={<LeaveTypeMaster />}
            />
          </Route>
          {/* <Route
            path={routes.allChangeRequest.match}
            element={<ChangeRequestList />}
          /> */}

          <Route path={routes.editCR.match} element={<DashboardGuard />}>
            <Route path={routes.editCR.match} element={<CRCreate />} />
          </Route>
          <Route path={routes.crView.match} element={<DashboardGuard />}>
            <Route path={routes.crView.match} element={<CRCreate />} />
          </Route>
        </Route>
      </Routes>
      <ToastContainer hideProgressBar={true} />
    </>
  );
};

export default AppWrapper;
